import axios from 'axios'
import {getAdminToken} from '../../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({
  withCredentials: true,
  validateStatus: (status) => (status >= 200 && status < 300) || status === 304,
})

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// The account a row belongs to. Repeated on every profile because a group can now
// span customers, so the owner is a property of the row, not of the group.
export interface DuplicateAccount {
  account_id: string
  account_name: string
  account_company: string
  account_email: string
  account_phone: string
  trial_period_end: string | null
}

export interface DuplicateProfile extends DuplicateAccount {
  _id: string
  name: string
  facebook_id: string
  facebook_username: string
  profile_picture_url: string
  hidden: boolean
  active: boolean
  is_logged_in: boolean
  autopost_enabled: boolean
  posts_per_day: number
  created_at: string | null
}

// 'account' = the same profile twice on one account; 'cross_account' = the same
// profile connected to different customers. Group-level account fields describe
// the first account and stay for compatibility; `accounts` is the real list.
export interface DuplicateGroup extends DuplicateAccount {
  scope: 'account' | 'cross_account'
  accounts: DuplicateAccount[]
  match_value: string
  count: number
  profiles: DuplicateProfile[]
}

export interface DuplicateSummary {
  active_trial_accounts: number
  duplicate_groups: number
  cross_account_groups: number
  extra_profiles: number
  accounts_affected: number
}

export interface DuplicateProfilesResponse {
  success: boolean
  summary: DuplicateSummary
  groups: DuplicateGroup[]
}

export function getDuplicateProfiles(): Promise<{data: DuplicateProfilesResponse}> {
  return adminApi.get(`${API_URL}/admin/duplicate-profiles`)
}
